import { IRootReducerState } from "../../../redux-store/rootReducer";
import { IAuditLogPayload, ServiceType } from "../../../types/audit";
import { resolveActor } from "../utils/resolveActor";
import { AnyAction } from "redux";
import { isEqual } from "lodash";
import { normalizeIntervals } from "../utils/normalizeIntervals";
import { ProcessedInterval } from "../../../types/Manager";

const SERVICE_TYPES: ServiceType[] = ["pickup", "delivery", "drive_thru"];

export const buildStoreWorkingHoursEntries = (
  action: AnyAction,
  state: IRootReducerState
): IAuditLogPayload[] => {
  const payload = action.payload as any;
  const { reason, __prevStoreHours, ...data } = payload;

  const beforeStore = __prevStoreHours as Record<string, ProcessedInterval[]> | undefined;
  const storeHoursState =
    beforeStore && Object.keys(beforeStore).length > 0
      ? beforeStore
      : state.getStoreWorkingHoursReducer || {};

  const { actor, actor_type, accountManager, store } = resolveActor(state);

  const entries: IAuditLogPayload[] = [];

  for (const serviceType of SERVICE_TYPES) {
    const intervalsKey = `${serviceType}_intervals` as keyof typeof data;
    const intervals = data[intervalsKey] as ProcessedInterval[];
    if (!intervals || intervals.length === 0) continue;

    const intervalsKeyState =
      `${serviceType}_intervals` as keyof typeof storeHoursState;
    const prevIntervals = (storeHoursState[intervalsKeyState] || []) as ProcessedInterval[];

    if (
      isEqual(normalizeIntervals(intervals), normalizeIntervals(prevIntervals))
    ) {
      continue;
    }

    entries.push({
      service_name: "order",
      action: "UPDATE",
      actor,
      actor_type,
      service_type: serviceType,
      entity_type: "working_hours",
      entity_id: store.id,
      entity_name: store.name,
      change_area: "store_working_hours",
      before_state: {
        intervals: prevIntervals,
      },
      after_state: { intervals },
      metadata: {
        account_manager: accountManager,
        reason,
        parent_type: "store",
        parent_id: store.id,
        parent_name: store.name,
        parent_image: store.image,
      },
    });
  }

  return entries;
};
